import Heading from '@/common/Heading';
import TextMeApp from '@/common/TextMeApp';
import Button from '@/components/Button';
import Text from '@/components/Text';
import { useEffect } from 'react';
import { useDownloadAppModal } from './DownloadAppModalContext';

export default function DownloadAppModal() {
  const { isOpen, closeModal, content } = useDownloadAppModal();

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeModal]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-primary/80 backdrop-blur-lg">
      <TextMeApp />
      <button
        onClick={closeModal}
        aria-label="Close"
        className="absolute top-4 right-4 flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
      <div className="w-full max-w-md mx-auto p-4">
        <div className="flex flex-col gap-6 items-center bg-darkglass p-8 rounded-xl text-center">
          {content ? (
            content
          ) : (
            <>
              <div className="text-5xl">📱</div>
              <div className="flex flex-col gap-2">
                <Heading className="font-game uppercase text-title-2">
                  Set Up Your Investment Account
                </Heading>
                <Text size="sm" className="text-secondary">
                  Complete your account setup on the Bloom app to trade 5,000+ stocks, ETFs, and crypto.
                </Text>
              </div>

              <Button id="text-button" size="md" className="w-full">
                Text me the app
              </Button>

              <button
                type="button"
                onClick={closeModal}
                className="text-secondary text-sm hover:underline"
              >
                Maybe later
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
